import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ElevateAppBar from './ElevateAppBar';
import ClientProvider from './client';
export default createDemo(import.meta.url, ElevateAppBar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/app-bar/demos/elevate/ElevateAppBar.tsx",
    "fileName": "ElevateAppBar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<{ elevation?: number }>;\n}\n\nfunction ElevationScroll(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    disableHysteresis: true,\n    threshold: 0,\n    target: window ? window() : undefined,\n  });\n\n  return children\n    ? React.cloneElement(children, {\n        elevation: trigger ? 4 : 0,\n      })\n    : null;\n}\n\nexport default function ElevateAppBar(props: Props) {\n  return (\n    <React.Fragment>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <CssBaseline />\n      <ElevationScroll {...props}>\n        <AppBar>\n          <Toolbar>\n            <Typography variant=\"h6\" component=\"div\">\n              Scroll to elevate App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n      </ElevationScroll>\n      <Toolbar />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </React.Fragment>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 65,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport AppBar from '@mui/material/AppBar';\nimport Toolbar from '@mui/material/Toolbar';\nimport Typography from '@mui/material/Typography';\nimport CssBaseline from '@mui/material/CssBaseline';\nimport useScrollTrigger from '@mui/material/useScrollTrigger';\nimport Box from '@mui/material/Box';\nimport Container from '@mui/material/Container';\n\ninterface Props {\n  /**\n   * Injected by the documentation to work in an iframe.\n   * You won't need it on your project.\n   */\n  window?: () => Window;\n  children?: React.ReactElement<{ elevation?: number }>;\n}\n\nfunction ElevationScroll(props: Props) {\n  const { children, window } = props;\n  // Note that you normally won't need to set the window ref as useScrollTrigger\n  // will default to window.\n  // This is only being set here because the demo is in an iframe.\n  const trigger = useScrollTrigger({\n    disableHysteresis: true,\n    threshold: 0,\n    target: window ? window() : undefined,\n  });\n\n  return children\n    ? React.cloneElement(children, {\n        elevation: trigger ? 4 : 0,\n      })\n    : null;\n}\n\nexport default function ElevateAppBar(props: Props) {\n  return (\n    <React.Fragment>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "      <CssBaseline />\n      <ElevationScroll {...props}>\n        <AppBar>\n          <Toolbar>\n            <Typography variant=\"h6\" component=\"div\">\n              Scroll to elevate App bar\n            </Typography>\n          </Toolbar>\n        </AppBar>\n      </ElevationScroll>\n      <Toolbar />\n      <Container>\n        <Box sx={{ my: 2 }}>\n          {[...new Array(12)]\n            .map(\n              () => `Cras mattis consectetur purus sit amet fermentum.\nCras justo odio, dapibus ac facilisis in, egestas eget quam.\nMorbi leo risus, porta ac consectetur ac, vestibulum at eros.\nPraesent commodo cursus magna, vel scelerisque nisl consectetur et.`,\n            )\n            .join('\\n')}\n        </Box>\n      </Container>\n"
      ],
      [
        "span",
        "frame",
        "    </React.Fragment>\n  );\n}\n"
      ]
    ],
    "totalLines": 65,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/AppBar",
      "@mui/material/Toolbar",
      "@mui/material/Typography",
      "@mui/material/CssBaseline",
      "@mui/material/useScrollTrigger",
      "@mui/material/Box",
      "@mui/material/Container"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
